import { z } from 'zod';

export const ContentAssetDTO = z.object({
    id: z.string(),
    body: z.string(),
    description: z.string().optional(),
    name: z.string().optional(),
    title: z.string().optional(),
});

export type ContentAsset = z.infer<typeof ContentAssetDTO>;

export const ContentAssetsDTO = z.object({
    assets: z.array(ContentAssetDTO),
});

export type ContentAssets = z.infer<typeof ContentAssetsDTO>;
